<div class="w-100 h-100">
    <div class="main_page w-100 h-100">
        <div class="container">
            <div class="row" style="padding-top: 50px;">
                <div class="col-12">
                    <div class="card card_layout">
                        <div class="card-header">
                            <label class="card_header_text">
                                {{$t('shared.AddProviderRequest')}}
                            </label>
                        </div>
                        <div class="card-body p-5">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>{{$t('shortPage.companyName')}}</label>
                                        <div class="input-group mb-3">
                                            <input class="form-control"
                                                    v-model="model.name" type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>{{$t('shared.enterpriseUnifiedNumber')}}</label>
                                        <div class="input-group mb-3">
                                            <input class="form-control"
                                                    v-model="model.enterpriseUnifiedNumber" type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>{{$t('shared.accreditationNumber')}}</label>
                                        <div class="input-group mb-3">
                                            <input class="form-control" type="text"
                                                     v-model="model.accreditationNumber" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>{{$t('shared.taxNumber')}}</label>
                                        <div class="input-group mb-3">
                                            <input class="form-control" type="text" maxlength="15"
                                                     v-model="model.taxNumber" @keypress="isNumberField($event)"
                                                   @paste="isNumberFieldPaste($event)" />
                                        </div>
                                        <small class="text-danger d-block" v-if="model.taxNumber.trim() !== '' && !isValidVatNumber(model.taxNumber)">{{$t('shared.invalidVatNumber')}}</small>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>{{$t('shared.email')}}</label>
                                        <div class="input-group mb-3">
                                            <input class="form-control" type="text"
                                                     v-model="model.email" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>{{$t('shared.expireDate')}}</label>
                                        <v-menu v-model="expireDateMenu" :close-on-content-click="false" :nudge-right="30" :nudge-bottom="30"transition="scale-transition"
                                                offset-y attach>
                                            <template v-slot:activator="{ on, attrs }">
                                                <div class="input-group mb-3">
                                                    <input class="form-control border-right-0 border-left" v-model="model.expireDate"
                                                           readonly v-bind="attrs" ref="createdDatePicker"
                                                           v-on="on" type="text" />
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text right gray">
                                                            <i class="far fa-calendar-alt"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </template>
                                            <v-date-picker v-model="model.expireDate"
                                                           no-title
                                                           scrollable
                                                           @input="expireDateMenu = false">
                                            </v-date-picker>
                                        </v-menu>
                                    </div>
                                </div>
                                <!-- sssssss -->
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>{{$t('shared.country')}}</label>
                                        <div class="input-group mb-3">
                                            <input class="form-control"
                                                    v-model="model.country" type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>{{$t('shared.city')}}</label>
                                        <div class="input-group mb-3">
                                            <input class="form-control"
                                                    v-model="model.city" type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>{{$t('shared.district')}}</label>
                                        <div class="input-group mb-3">
                                            <input class="form-control"
                                                    v-model="model.district" type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>{{$t('shared.streetName')}}</label>
                                        <div class="input-group mb-3">
                                            <input class="form-control"
                                                    v-model="model.streetName" type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>{{$t('shared.buildingNumber')}}</label>
                                        <div class="input-group mb-3">
                                            <input class="form-control"
                                                    v-model="model.buildingNumber" type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>{{$t('shared.postalCode')}}</label>
                                        <div class="input-group mb-3">
                                            <input class="form-control"
                                                    v-model="model.postalCode" type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>{{$t('shared.vatNumber')}}</label>
                                        <div class="input-group mb-3">
                                            <input class="form-control" maxlength="15"
                                                    v-model="model.vatNumber" type="text"
                                                   @keypress="isNumberField($event)"
                                                   @paste="isNumberFieldPaste($event)" />
                                        </div>
                                        <small class="text-danger d-block" v-if="model.vatNumber.trim() !== '' && !isValidVatNumber(model.vatNumber)">{{$t('shared.invalidVatNumber')}}</small>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>{{$t('shared.additionalNumber')}}</label>
                                        <div class="input-group mb-3">
                                            <input class="form-control"
                                                    v-model="model.additionalNumber" type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>{{$t('shared.otherIdentifier')}}</label>
                                        <div class="input-group mb-3">
                                            <input class="form-control"
                                                    v-model="model.otherIdentifier" type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-6 col-12 pt-3">
                                            <div class="form-group">
                                                <div class="input-group mb-1">
                                                    <input type="file" ref="providerFile" hidden accept=".pdf,.docx" @change="onProviderFilePicked" />
                                             <input :placeholder="$t('shared.addAttachment')" @click="onPickProviderFile"
                                                    class="form-control border-right-0 border-left" readonly
                                                    style="cursor: pointer;"
                                                    v-model="selectedProviderFileName"
                                                    :class="{ 'is-invalid': !!providerFileError }" type="text" :aria-invalid="!!providerFileError"
                                                        aria-describedby="providerFileErrorMsg" />
                                                </div>
                                                <small v-if="providerFileError" id="providerFileErrorMsg" class="text-danger d-block">
                                                    {{ providerFileError }}
                                                </small>
                                            </div>
                                        </div>                              
                                        <div class="col-md-4 pt-3">
                                            <div class="form-group">
                                                <v-select v-model="selectedProviderAttachmentCategory" :items="providerAttachmentCategoryList"
                                                    :label="$t('shared.addCategory')" item-text="name" item-value="id" solo attach />
                                            </div>
                                        </div>                              
                                        <div class="input-group-prepend pt-3">
                                            <span style="padding: 4px;">
                                                <button :disabled="!canAddProviderAttachment || !!providerFileError" @click="addProviderAttachment"
                                                    class="btn btn-primary">
                                                    {{$t('shared.add')}}
                                                </button>
                                            </span>
                                        </div>
                                        <div class="col-md-12" style="width:100%;">
                                            <label class="d-inline-flex align-items-center" style="justify-content:flex-start; gap:4px;">
                                                {{$t('shared.attachment')}}
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon v-bind="attrs" v-on="on" small class="align-middle"
                                                            :style="{ color: 'var(--color-Main)' }">
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span style="white-space: pre-line">
                                                        {{$t('shared.theMaximumSizeForTheAttachmentIs3Megabytes')}}
                                                    </span>
                                                </v-tooltip>
                                            </label>
                                            <ul class="list-group list_Sender scrollbar" style="width:100%; max-width:100%; margin:0; padding:0;">
                                                <template v-if="providerUploadedAttachments.length">
                                                    <li class="list-group-item" v-for="(item, index) in providerUploadedAttachments"
                                                        :key="item.categoryId + '-' + index"
                                                        style="display:flex; align-items:flex-start; justify-content:space-between; gap:12px; width:100%; padding:12px 16px;">
                                                        <div style="flex:1 1 auto;">
                                                            <span class="box-name"
                                                                style="display:inline; white-space:normal; overflow-wrap:anywhere; word-break:break-word; vertical-align:middle;">
                                                                {{ item.fileName }}
                                                            </span>
                                                            <span class="box-name" style="vertical-align:middle;"> — {{ item.categoryName }}</span>
                                                        </div>
                                                        <div style="display:flex; align-items:center; gap:12px; flex:0 0 auto; margin-top:2px;">
                                                            <i class="fas fa-sync-alt" title="Replace" @click.stop="replaceProviderAttachment(index)"
                                                                style="cursor:pointer;"></i>
                                                            <i class="far fa-trash-alt Icon_delete" title="Delete"
                                                                @click.stop="deleteProviderAttachment(index)" style="cursor:pointer;"></i>
                                                        </div>
                                                    </li>
                                                </template>
                                                <li v-else class="list-group-item" style="width:100%; padding:12px 16px;">
                                                    {{$t('shared.noAttachments')}}
                                                </li>
                                            </ul>                                
                                            <small v-if="providerListError" class="text-danger d-block mt-1" id="providerListErrorMsg">
                                                {{ providerListError }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-5">
                                </div>
                                <div class="row col-md-12 mt-4">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>{{$t('shared.userNameAdmin')}}</label>
                                            <div class="input-group mb-3">
                                                <input class="form-control"
                                                        v-model="model.username" type="text" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>{{$t('shared.userEmailAdmin')}}</label>
                                            <div class="input-group mb-3">
                                                <input class="form-control" type="text"
                                                         v-model="model.useremail" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>{{$t('shared.phoneNumberAdmin')}}</label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text gray">
                                                        +966
                                                    </span>
                                                </div>
                                                <input class="form-control border-left-0" @change="isMobileNumberValid" @paste="isNumberFieldPaste($event)" maxlength="9" @keypress="isNumberField($event)" v-model="model.mobile" type="text" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 mt-5">
                                    <div class="form-row justify-content-end align-items-center">
                                        <div class="col-auto mx-3">
                                            <router-link to="/login" tag="a" class="link_secondary">{{$t('shared.cancel')}}</router-link>
                                        </div>
                                        <div class="col-auto">
                                            <button class="btn btn-success px-5 py-2"
                                                    @click="addProviderRequest" :disabled="!isValid">
                                                {{$t('shared.apply')}}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <v-dialog v-model="otpDialog" persistent width="554">
                <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title>
                        <label class="login_header">
                            {{$t('shared.emailVerification')}}
                        </label>
                        <div class="close__dialog">
                            <i class="fas fa-times" @click="hideOtpDialog"></i>
                        </div>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <p class="mt-3 text_body">
                            {{$t('shared.otpSentToEmail')}}
                        </p>
                        <div class="row row_input pb-4">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="input-group mb-3">
                                        <input type="text" class="form-control text-center" v-model="otp"
                                               maxlength="6" @keypress="isNumberField($event)"
                                               :placeholder="$t('shared.enterVerificationCode')" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p v-if="otpExpired" class="text-danger">
                            {{$t('shared.otpExpiredMessage')}}
                        </p>
                        <p v-if="otpErrorMessage && !otpExpired" class="text-danger">
                            {{ otpErrorMessage }}
                        </p>
                        <label v-if="resendCountDown > 0" class="w-100 text-center text_body">
                            {{$t('shared.otpResendCountDown')}}: {{ formattedResendCountDown }}
                        </label>
                        <v-card-actions class="row_input row_button form-row justify-content-center align-items-center py-0">
                            <div class="form-row justify-content-center align-items-center">
                                <div class="col-auto">
                                    <button class="btn btn-primary" :disabled="isResendDisabled" @click="resendOTP">
                                        {{$t('loginPage.resendOtp')}}
                                    </button>
                                    <button class="btn btn-success" :disabled="!otp || otp.length !== 6 || otpExpired" @click="verifyOTP">
                                        {{$t('shared.verify')}}
                                    </button>
                                </div>
                            </div>
                        </v-card-actions>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <div class="login_footer form-row justify-content-between align-items-center">
                <div class="col-auto">
                    <a>
                        {{$t('shared.privacy')}}
                    </a>
                </div>
                <div class="col-auto">
                    <a>
                        {{$t('shared.termsOfUse')}}
                    </a>
                </div>
                <div class="col-auto">
                    <a>
                        {{$t('shared.copyRight')}} {{currentYear}}
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

